export const CoreLabels: { [key: string] : any } = {
    currency: {
        bg: ' лв.',
        en: ' eur.'
    }
}